import Config from '@qover/utils/src/Config';
import Step, { Path } from '../domain/Step';
import { nextButtonMessages } from '../bike.messages';
import {
  policyholderValidation,
  summaryValidation,
  bikeValidation,
  bikeConditionValidation,
  quoteValidation,
  finalizationValidation,
} from './bikeValidation';

export const BASE_PATH = Config.getApiUrl('bike');

export const PICTURE_PARTIAL_CONTRACT_COUNT = 5;

export const STEPS = [
  new Step({
    initialPath: 'quote',
    paths: [
      new Path({
        path: 'quote',
        nextPath: 'policyholder',
        validate: quoteValidation,
      }),
    ],
  }),
  new Step({
    initialPath: 'policyholder',
    paths: [
      new Path({
        path: 'policyholder',
        nextPath: 'bike',
        validate: policyholderValidation,
      }),
    ],
  }),
  new Step({
    initialPath: 'bike',
    paths: [
      new Path({
        path: 'bike',
        nextPath: 'bike-condition',
        remarketing: 'policyholder',
        validate: bikeValidation,
      }),
      new Path({
        path: 'bike-condition',
        nextPath: 'bike-serial-number',
        validate: bikeConditionValidation,
      }),
      new Path({
        path: 'bike-serial-number',
        nextPath: 'finalization',
      }),
    ],
  }),
  new Step({
    initialPath: 'finalization',
    paths: [
      new Path({
        path: 'finalization',
        nextPath: 'summary',
        validate: finalizationValidation,
      }),
      new Path({
        path: 'summary',
        buttonTitle: nextButtonMessages.payNow,
        remarketing: 'summary',
        validate: summaryValidation,
      }),
      new Path({
        path: 'payment',
        fetchTerms: false,
        showFaq: false,
        showFooter: false,
        showLegalMentions: false,
      }),
      new Path({
        path: 'confirmation',
        redirectWithDraftId: false,
        fetchTerms: false,
        showFaq: false,
      }),
    ],
  }),
];

export const MOBILE_STEPS = STEPS;
